<template>
<body class="u-body u-xl-mode" data-lang="en"><header class="u-clearfix u-header u-valign-bottom-sm u-valign-bottom-xs u-header" id="sec-52d1"><a href="#" class="u-image u-logo u-image-1" data-image-width="498" data-image-height="505" title="Home">
        <img src="../../../assets/warranty-images/logo-anewday_1full_color.webp" class="u-logo-image u-logo-image-1">
      </a><nav class="u-menu u-menu-one-level u-offcanvas u-menu-1">
        <div class="menu-collapse u-custom-font" style="font-size: 1.125rem; letter-spacing: 0px; font-family: Kanit;">
          <a class="u-button-style u-custom-left-right-menu-spacing u-custom-padding-bottom u-custom-top-bottom-menu-spacing u-nav-link u-text-active-palette-1-base u-text-hover-palette-2-base" href="#">
            <svg class="u-svg-link" viewBox="0 0 24 24"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#menu-hamburger"></use></svg>
            <svg class="u-svg-content" version="1.1" id="menu-hamburger" viewBox="0 0 16 16" x="0px" y="0px" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns="http://www.w3.org/2000/svg"><g><rect y="1" width="16" height="2"></rect><rect y="7" width="16" height="2"></rect><rect y="13" width="16" height="2"></rect>
</g></svg>
          </a>
        </div>
        <div class="u-custom-menu u-nav-container">
          <ul class="u-custom-font u-nav u-unstyled u-nav-1"><li class="u-nav-item"><a class="u-button-style u-nav-link u-text-active-palette-1-base u-text-hover-palette-2-base" href="https://anewday.co.th" style="padding: 10px 20px;">Home</a>
</li><li class="u-nav-item"><a class="u-button-style u-nav-link u-text-active-palette-1-base u-text-hover-palette-2-base" href="https://anewday.co.th/en/shop/" style="padding: 10px 20px;">Products</a>
</li></ul>
        </div>
        <div class="u-custom-menu u-nav-container-collapse">
          <div class="u-black u-container-style u-inner-container-layout u-opacity u-opacity-95 u-sidenav">
            <div class="u-inner-container-layout u-sidenav-overflow">
              <div class="u-menu-close"></div>
              <ul class="u-align-center u-nav u-popupmenu-items u-unstyled u-nav-2"><li class="u-nav-item"><a class="u-button-style u-nav-link" href="https://anewday.co.th">Home</a>
</li><li class="u-nav-item"><a class="u-button-style u-nav-link" href="https://anewday.co.th/en/shop/">Products</a>
</li></ul>
            </div>
          </div>
          <div class="u-black u-menu-overlay u-opacity u-opacity-70"></div>
        </div>
      </nav></header>
    <section class="u-align-center u-clearfix u-image u-shading u-section-1" src="" data-image-width="1920" data-image-height="775" id="sec-aa94">
      <div class="u-clearfix u-sheet u-valign-middle-xl u-sheet-1">
        <h1 class="u-custom-font u-text u-title u-text-1">Online Warranty<br>&nbsp;Registration
        </h1>
        <p class="u-custom-font u-large-text u-text u-text-variant u-text-2"> กรุณาลงทะเบียนการรับประกันสินค้า<br>เพื่อประโยชน์ในการรับบริการในอนาคต
        </p>
        <a href="https://warranty.anewday.co.th/warranty-condition-th" class="u-btn u-button-style u-custom-font u-palette-2-base u-btn-1" style="background-color:#f29802 !important">Read More</a>
      </div>
    </section>
    <section class="u-clearfix u-section-2" id="sec-be2d">
      <div class="u-clearfix u-sheet u-valign-middle u-sheet-1">
        <h2 class="u-align-center u-custom-font u-text u-text-default u-text-1">You already registered warranty&nbsp;<br>this serial number
        </h2>
        <a href="https://anewday.co.th/en/shop/" class="u-btn u-button-style u-custom-font u-palette-2-base u-btn-1" style="background-color:#f29802 !important">Shop More Products</a>
      </div>
    </section>
    
    
    <footer class="u-clearfix u-footer u-grey-80" id="sec-3f03"><div class="u-clearfix u-sheet u-sheet-1">
        <div class="u-align-left u-social-icons u-spacing-10 u-social-icons-1">
          <a class="u-social-url" target="_blank" data-type="Custom" title="Line" href="https://line.me/R/ti/p/%40blackholethailand"><span class="u-file-icon u-icon u-social-custom u-social-icon u-icon-1"><img src="../../../assets/warranty-images/3670089.png" alt=""></span>
          </a>
          <a class="u-social-url" title="facebook" target="_blank" href="https://www.facebook.com/blackholethailand/"><span class="u-icon u-social-facebook u-social-icon u-icon-2"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-5e5c"></use></svg><svg class="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-5e5c"><circle fill="currentColor" cx="56.1" cy="56.1" r="55"></circle><path fill="#FFFFFF" d="M73.5,31.6h-9.1c-1.4,0-3.6,0.8-3.6,3.9v8.5h12.6L72,58.3H60.8v40.8H43.9V58.3h-8V43.9h8v-9.2
            c0-6.7,3.1-17,17-17h12.5v13.9H73.5z"></path></svg></span>
          </a>
          <a class="u-social-url" title="instagram" target="_blank" href="https://www.instagram.com/blackholethailand/"><span class="u-icon u-social-icon u-social-instagram u-icon-3"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-4e65"></use></svg><svg class="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-4e65"><circle fill="currentColor" cx="56.1" cy="56.1" r="55"></circle><path fill="#FFFFFF" d="M55.9,38.2c-9.9,0-17.9,8-17.9,17.9C38,66,46,74,55.9,74c9.9,0,17.9-8,17.9-17.9C73.8,46.2,65.8,38.2,55.9,38.2
            z M55.9,66.4c-5.7,0-10.3-4.6-10.3-10.3c-0.1-5.7,4.6-10.3,10.3-10.3c5.7,0,10.3,4.6,10.3,10.3C66.2,61.8,61.6,66.4,55.9,66.4z"></path><path fill="#FFFFFF" d="M74.3,33.5c-2.3,0-4.2,1.9-4.2,4.2s1.9,4.2,4.2,4.2s4.2-1.9,4.2-4.2S76.6,33.5,74.3,33.5z"></path><path fill="#FFFFFF" d="M73.1,21.3H38.6c-9.7,0-17.5,7.9-17.5,17.5v34.5c0,9.7,7.9,17.6,17.5,17.6h34.5c9.7,0,17.5-7.9,17.5-17.5V38.8
            C90.6,29.1,82.7,21.3,73.1,21.3z M83,73.3c0,5.5-4.5,9.9-9.9,9.9H38.6c-5.5,0-9.9-4.5-9.9-9.9V38.8c0-5.5,4.5-9.9,9.9-9.9h34.5
            c5.5,0,9.9,4.5,9.9,9.9V73.3z"></path></svg></span>
          </a>
          <a class="u-social-url" title="twitter" target="_blank" href="https://twitter.com/blackholeTH2017"><span class="u-icon u-social-icon u-social-twitter u-icon-4"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-e7f2"></use></svg><svg class="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-e7f2"><circle fill="currentColor" class="st0" cx="56.1" cy="56.1" r="55"></circle><path fill="#FFFFFF" d="M83.8,47.3c0,0.6,0,1.2,0,1.7c0,17.7-13.5,38.2-38.2,38.2C38,87.2,31,85,25,81.2c1,0.1,2.1,0.2,3.2,0.2
            c6.3,0,12.1-2.1,16.7-5.7c-5.9-0.1-10.8-4-12.5-9.3c0.8,0.2,1.7,0.2,2.5,0.2c1.2,0,2.4-0.2,3.5-0.5c-6.1-1.2-10.8-6.7-10.8-13.1
            c0-0.1,0-0.1,0-0.2c1.8,1,3.9,1.6,6.1,1.7c-3.6-2.4-6-6.5-6-11.2c0-2.5,0.7-4.8,1.8-6.7c6.6,8.1,16.5,13.5,27.6,14
            c-0.2-1-0.3-2-0.3-3.1c0-7.4,6-13.4,13.4-13.4c3.9,0,7.3,1.6,9.8,4.2c3.1-0.6,5.9-1.7,8.5-3.3c-1,3.1-3.1,5.8-5.9,7.4
            c2.7-0.3,5.3-1,7.7-2.1C88.7,43,86.4,45.4,83.8,47.3z"></path></svg></span>
          </a>
          <a class="u-social-url" target="_blank" data-type="YouTube" title="YouTube" href="https://www.youtube.com/channel/UC5her_rmFbYJ_NtPL2AypvQ"><span class="u-icon u-social-icon u-social-youtube u-icon-5"><svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 112 112" style=""><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-b8fd"></use></svg><svg class="u-svg-content" viewBox="0 0 112 112" x="0" y="0" id="svg-b8fd"><circle fill="currentColor" cx="56.1" cy="56.1" r="55"></circle><path fill="#FFFFFF" d="M74.9,33.3H37.3c-7.4,0-13.4,6-13.4,13.4v18.8c0,7.4,6,13.4,13.4,13.4h37.6c7.4,0,13.4-6,13.4-13.4V46.7 C88.3,39.3,82.3,33.3,74.9,33.3L74.9,33.3z M65.9,57l-17.6,8.4c-0.5,0.2-1-0.1-1-0.6V47.5c0-0.5,0.6-0.9,1-0.6l17.6,8.9 C66.4,56,66.4,56.8,65.9,57L65.9,57z"></path></svg></span>
          </a>
        </div>
        <div class="u-expanded-width u-layout-grid u-list u-list-1">
          <div class="u-repeater u-repeater-1">
            <div class="u-align-left u-container-style u-custom-color-1 u-list-item u-radius-20 u-repeater-item u-shape-round u-list-item-1" data-animation-name="bounceIn" data-animation-duration="1500" data-animation-direction="Right" data-animation-delay="500">
              <div class="u-container-layout u-similar-container u-container-layout-1">
                <h5 class="u-custom-font u-text u-text-1"><span class="u-file-icon u-icon u-text-white"><img src="../../../assets/warranty-images/597177-de35359a.png" alt=""></span>&nbsp;Call Us
                </h5>
                <p class="u-text u-text-2">
                  <a class="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-hover-palette-1-base u-text-white u-btn-1" href="tel:02-725-0841"> 02-725-0841</a>
                </p>
              </div>
            </div>
            <div class="u-align-left u-container-style u-custom-color-1 u-list-item u-radius-20 u-repeater-item u-shape-round u-list-item-2" data-animation-name="bounceIn" data-animation-duration="1500" data-animation-direction="Right" data-animation-delay="500">
              <div class="u-container-layout u-similar-container u-container-layout-2">
                <h5 class="u-custom-font u-text u-text-3"><span class="u-file-icon u-icon"><img src="../../../assets/warranty-images/email-icons-white-color-958812.jpg" alt=""></span>&nbsp;Email
                </h5>
                <p class="u-custom-font u-text u-text-4">
                  <a class="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-hover-palette-1-base u-text-white u-btn-2" href="mailto:online@anewday.co.th"> online@anewday.co.th</a>
                </p>
              </div>
            </div>
            <div class="u-align-left u-container-style u-custom-color-1 u-list-item u-radius-20 u-repeater-item u-shape-round u-list-item-3" data-animation-name="bounceIn" data-animation-duration="1500" data-animation-direction="Right" data-animation-delay="500">
              <div class="u-container-layout u-similar-container u-container-layout-3">
                <h5 class="u-custom-font u-text u-text-5"><span class="u-file-icon u-icon u-text-white"><img src="../../../assets/warranty-images/484167-0f572cc8.png" alt=""></span> A New Day Co.,Ltd 
                </h5>
                <p class="u-custom-font u-text u-text-6">
                  <a class="u-active-none u-border-none u-btn u-button-link u-button-style u-hover-none u-none u-text-hover-palette-1-base u-text-white u-btn-3" href="https://www.google.com/maps?ll=13.775506,100.596097&amp;z=20&amp;t=m&amp;hl=en&amp;gl=TH&amp;mapclient=embed&amp;cid=6701663887302958155"> 634/4 Soi. Ramkhamheang 39 ( Theplila 1 ), Phachautit Rd., Wangthonglang, Bangkok 10310 Thailand </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div></footer>
    <!--<section class="u-backlink u-clearfix u-grey-80">
      <a class="u-link" href="https://nicepage.com/website-templates" target="_blank">
        <span>Website Templates</span>
      </a>
      <p class="u-text">
        <span>created with</span>
      </p>
      <a class="u-link" href="" target="_blank">
        <span>Website Builder Software</span>
      </a>. 
    </section><span style="height: 64px; width: 64px; margin-left: 0px; margin-right: auto; margin-top: 0px; background-image: none; right: 20px; bottom: 20px; padding: 15px;" class="u-back-to-top u-icon u-icon-circle u-opacity u-opacity-85 u-palette-1-base" data-href="#">
        <svg class="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 551.13 551.13"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#svg-1d98"></use></svg>
        <svg class="u-svg-content" enable-background="new 0 0 551.13 551.13" viewBox="0 0 551.13 551.13" xmlns="http://www.w3.org/2000/svg" id="svg-1d98"><path d="m275.565 189.451 223.897 223.897h51.668l-275.565-275.565-275.565 275.565h51.668z"></path></svg>
    </span>-->
  
</body>

</template>

<script>

export default {
  created(){
    document.title = "A New Day Warranty"
  }, 
  mounted() {
    localStorage.removeItem('ANEWDAY_LOT')
  },
  methods: {
    async next() {
      window.location.href = 'https://anewday.co.th';
    }
  }
}
</script>

<style scoped>
 .u-section-1 {
  background-image: linear-gradient(0deg, rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url("../../../assets/warranty-images/banner-home1.webp");
  background-position: 50% 50%;
}

.u-section-1 .u-sheet-1 {
  min-height: 368px;
}

.u-section-1 .u-text-1 {
  font-family: Kanit;
  font-size: 3.75rem;
  font-weight: normal;
  margin: 32px 453px 0 0;
}

.u-section-1 .u-text-2 {
  font-size: 1.25rem;
  font-family: Kanit;
  margin: 30px 453px 0 0;
}

.u-section-1 .u-btn-1 {
  background-image: none;
  font-family: Kanit;
  font-size: 1.125rem;
  text-transform: uppercase;
  font-weight: 500;
  margin: 30px auto 32px 264px;
}

@media (max-width: 1199px) {
  .u-section-1 .u-sheet-1 {
    min-height: 332px;
  }

  .u-section-1 .u-text-1 {
    font-size: 3rem;
    width: auto;
    margin-right: 370px;
  }

  .u-section-1 .u-text-2 {
    font-size: 1.125rem;
    width: auto;
    margin-right: 370px;
  }

  .u-section-1 .u-btn-1 {
    margin-top: 32px;
    margin-bottom: 30px;
    margin-left: 205px;
  }
}

@media (max-width: 991px) {
  .u-section-1 .u-sheet-1 {
    min-height: 297px;
  }

  .u-section-1 .u-text-1 {
    font-size: 2.25rem;
    margin-right: 286px;
  }

  .u-section-1 .u-text-2 {
    font-size: 1rem;
    margin-right: 286px;
  }

  .u-section-1 .u-btn-1 {
    font-size: 1rem;
    margin-left: 143px;
  }
}

@media (max-width: 767px) {
  .u-section-1 .u-text-1 {
    margin-right: 196px;
  }

  .u-section-1 .u-text-2 {
    margin-right: 196px;
  }

  .u-section-1 .u-btn-1 {
    margin-left: 98px;
  }
}

@media (max-width: 575px) {
  .u-section-1 .u-sheet-1 {
    min-height: 270px;
  }

  .u-section-1 .u-text-1 {
    font-size: 1.75rem;
    margin-top: 31px;
    margin-right: 102px;
  }

  .u-section-1 .u-text-2 {
    font-size: 0.875rem;
    margin-right: 109px;
  }

  .u-section-1 .u-btn-1 {
    font-size: 0.875rem;
    margin-bottom: 31px;
    margin-left: 51px;
  }
}.u-section-2 .u-sheet-1 {
  min-height: 329px;
}

.u-section-2 .u-text-1 {
  font-family: Kanit;
  font-size: 2.25rem;
  background-image: none;
  line-height: 1.4;
  margin: 60px auto 0;
}

.u-section-2 .u-btn-1 {
  background-image: none;
  letter-spacing: 2px;
  font-size: 1.125rem;
  font-family: Kanit;
  text-transform: uppercase;
  font-weight: 500;
  margin: 60px auto 59px;
}

@media (max-width: 991px) {
  .u-section-2 .u-btn-1 {
    font-size: 1rem;
  }
}

@media (max-width: 575px) {
  .u-section-2 .u-text-1 {
    font-size: 1.5rem;
  }

  .u-section-2 .u-btn-1 {
    font-size: 0.875rem;
  }
}
</style>
